<template>
  <div class="my-item round-corner">
    <div class="hd">
      <h3 class="title van-multi-ellipsis--l2">{{ item.FLOWNAME }}</h3>
    </div>
    <div class="num-wrap">
        <div class="num-item" @click="tranTo(item.FLOWNAME,item.OPENID,'send')">
          <h4 class="num-ongoing">{{ item.SEND }}</h4>
          <p>进行中</p>
        </div>
        <div class="num-item" @click="tranTo(item.FLOWNAME,item.OPENID,'end')">
          <h4 class="num-end">{{ item.END }}</h4>
          <p>已结束</p>
        </div>
        <div class="num-item" @click="tranTo(item.FLOWNAME,item.OPENID,'draft')">
          <h4 class="num-draft">{{ item.DRAFT }}</h4>
          <p>草稿箱</p>
        </div>
    </div>
  </div>
</template>

<script>
import {formatDateTimeToNow} from "@/utils/dateTimeUtil"
import {locationTo} from "@/utils/url";
export default {
  name: 'MyItem',
  components: {},
  data() {
    return {}
  },
  computed: {},
  props: ['item'],
  mounted() {
  },
  methods: {
    formatDateTimeToNow,locationTo,
    tranTo(FLOWNAME,openId,itemType){
      console.log("进来了")
      this.$router.push({
        path:"/visitorApply/"+openId,
        query:{
          "flowName":FLOWNAME,
          "itemType":itemType,
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.my-item {
  position: relative;
  background-color: #ffffff;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  .hd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;

    .title {
      line-height: 1.2em;
      color: #333;
      font-weight: 400;
      @extend .font14;
    }

    .time {
      border-radius: 50px;
      padding: 2px 8px;
      color: #999;
      flex-shrink: 0;
      margin-left: 15px;
      user-select: none;
      @extend .font12;
    }
  }

  .num-wrap {
    display: flex;
    justify-content: space-around;

    .num-item {
      text-align: center;
      padding: 10px 0;
      flex-grow: 1;

      h4 {
        font-weight: normal;
        line-height: 24px;
        user-select: none;
        @extend .font16;
      }

      p {
        color: #666;
        -webkit-user-select: none;
        user-select: none;
        @extend .font12;
      }
    }

    .num-item:active {
      background: #f2f3f5;
    }

    .transfer-box {
      flex: 1;
      padding: 10px 0;
      @extend .font14;
    }
  }


  .num-todo {
    color: #ef4f4f;
  }

  .num-done {
    color: #04be02;
  }

  .num-copy {
    color: #ffbe00;
  }

  .num-ongoing {
    color: #007aff;
  }

  .num-end {
    color: #04be02;
  }

  .num-draft {
    color: #ffbe00;
  }
}

.my-item:before {
  position: absolute;
  left: 0;
  top: 10px;
  content: "";
  display: block;
  width: 6px;
  height: 22px;
  border-radius: 0 2px 2px 0;
  background: #efefef;
}
</style>
